import React from 'react';
import Checkbox from '../../components/Checkbox';
import Input from '../../components/Input';
import RadioGroup from '../../components/RadioGroup';
import SelectDropdown from '../../components/SelectDropdown';

const CommonComponentDemo = () => {
  const options = [
    { label: 'opt1', value: 'opt' },
    { label: 'opt2', value: 'opt2' },
    { label: 'opt3', value: 'opt3' },
    { label: 'opt4', value: 'opt4' },
    { label: 'opt5', value: 'opt5' },
    { label: 'opt6', value: 'opt6' },
    { label: 'opt7', value: 'opt7' },
  ];
  const groupTitle = 'options';
  return (
    <div style={{ padding: 20 }}>
      <SelectDropdown options={options} label={''} defaultValue={options[3].value} />
      <Checkbox fontSize={28} defaultChecked={false} label={'label'} />
      <div>
        <RadioGroup
          options={options}
          groupTitle={groupTitle}
          defaultRadioValue={options[2].value}
        />
      </div>
      <Input variant={'standard'} label={'Enter input'} width={'300px'} />
    </div>
  );
};

export default CommonComponentDemo;
